<nav
  class="navbar bg-primary text-white navbar-dark navbar-expand-lg d-none d-lg-flex"
  [ngClass]="{
    'tt-navbar': isTicketTransfer,
  }"
>
  <ng-container *notInPopulation="[populations.TicketTransfer]">
    <a
      class="navbar-brand py-0"
      [routerLink]="['/']"
      routerLinkActive="router-link-active"
      attr.aria-label="{{ 'nav.home.page.screenreader' | translate: { fgbdefault: 'Move to home page' } }}"
    >
      <label id="homeLink" class="accessibility-only">Go To Home Page</label>
      <img class="home-image" [src]="'logos/rewards-logo.png' | contentAssetImage" draggable="false" />
    </a>
  </ng-container>

  <ng-container *inPopulation="[populations.TicketTransfer]">
    <a
      class="navbar-brand py-0"
      [routerLink]="['/ticketTransfer']"
      routerLinkActive="router-link-active"
      attr.aria-label="{{ 'nav.home.page.screenreader' | translate: { fgbdefault: 'Move to home page' } }}"
    >
      <img alt="" class="ticket-transfer-logo" [src]="'logos/rewards-logo.png' | contentAssetImage" draggable="false" />
    </a>
  </ng-container>

  <button
    class="navbar-toggler"
    type="button"
    (click)="isCollapsed = !isCollapsed"
    aria-controls="navbarSupportedContent"
    aria-expanded="false"
    attr.aria-label="{{ 'nav.toggle.screenreader' | translate }}"
  >
    <span class="navbar-toggler-icon"></span>
  </button>

  <!-- right Side Content -->
  <div class="right-side-container">
    <ng-container *notInPopulation="[populations.TicketTransfer]">
      <a class="club-site" href="{{ 'nav.club.site.url' | translate }}" target="_blank">
        {{ 'nav.club.site' | translate }}
      </a>
    </ng-container>
    <div
      class="navbar-collapse"
      [ngbCollapse]="isCollapsed"
      id="navbarSupportedContent"
      [ngClass]="{
        'tt-navbar-collapse': isTicketTransfer,
      }"
    >
      <ng-container *notInPopulation="[populations.TicketTransfer]">
        <div class="nav-container">
          <ul class="navbar-nav" #greedyNav>
            <li class="nav-item active">
              <a
                class="nav-link mx-1"
                [routerLink]="['/rewards']"
                routerLinkActive="router-link-active"
                attr.aria-label="{{ 'nav.rewards.screenreader' | translate: { fgbdefault: 'Move to rewards page' } }}"
                >{{ 'nav.rewards' | translate }}</a
              >
            </li>
            <li class="nav-item active">
              <a
                class="nav-link mx-1"
                [routerLink]="['/challenges']"
                routerLinkActive="router-link-active"
                attr.aria-label="{{ 'nav.challenges.screenreader' | translate: { fgbdefault: 'Move to challenges page' } }}"
                >{{ 'nav.challenges' | translate }}</a
              >
            </li>
            <li class="nav-item active">
              <a
                class="nav-link mx-1"
                [routerLink]="['/games']"
                routerLinkActive="router-link-active"
                attr.aria-label="{{ 'nav.games.screenreader' | translate: { fgbdefault: 'Move to games page' } }}"
                >{{ 'nav.games' | translate }}</a
              >
            </li>

            <li class="nav-item active">
              <a
                class="nav-link mx-1"
                [routerLink]="['/rewards/wallet']"
                routerLinkActive="router-link-active"
                attr.aria-label="{{ 'nav.wallet.screenreader' | translate: { fgbdefault: 'Move to Wallet page' } }}"
                >{{ 'nav.wallet' | translate }}</a
              >
            </li>

            <ng-container *notInPopulation="[populations.U18]">
              <ng-container *fgbWebsiteContentFeatureFlag="'feature.flag.offers'">
                <li class="nav-item active">
                  <a
                    class="nav-link mx-1"
                    [routerLink]="['/offers']"
                    routerLinkActive="router-link-active"
                    attr.aria-label="{{ 'nav.offers.screenreader' | translate: { fgbdefault: 'Move to Offer page' } }}"
                    >{{ 'nav.offer' | translate }}</a
                  >
                </li>
              </ng-container>
            </ng-container>
          </ul>
        </div>
      </ng-container>

      <!--New Dropdown (Needs Manage Tickets update before being looked at again)-->
      <div class="member" ngbDropdown #ddAccount="ngbDropdown" [autoClose]="'outside'">
        <ng-container *notInPopulation="[populations.U18, populations.TicketTransfer]">
          <div class="ecash bg-glass mx-0 me-2">
            <div class="d-flex align-items-center justify-content-center" *ngIf="loyaltyPointsCard$">
              <span class="icons material-symbols-outlined text-white" aria-hidden="true">money_bag</span>
              <label class="fw-bold text-white mb-0">{{ ecash$ | async | FortressCurrencyPipe }}</label>
            </div>
          </div>
          <div class="balance bg-glass mx-0">
            <div class="d-flex align-items-center justify-content-center" *ngIf="loyaltyPointsCard$">
              <span class="icons material-icons text-white" aria-hidden="true">loyalty</span>
              <label class="fw-bold text-white mb-0"
                >{{ loyaltyPointsCard$ | async | number: '1.0-0' }} {{ 'fgbcl.currency.pts' | translate }}</label
              >
            </div>
          </div>
        </ng-container>
        <ng-container *notInPopulation="[populations.TicketTransfer]"
          ><fgb-notification-button></fgb-notification-button>
        </ng-container>

        <button
          class="nav-link border-0 d-flex align-items-center mx-2 px-0 justify-content-end"
          id="namedropdown"
          (click)="isNavOpen = !isNavOpen"
          attr.aria-label="{{ 'nav.account.dropdown.screenreader' | translate: { fgbdefault: 'Click for more account menu' } }}"
          tabindex="-1"
        >
          <div type="button" class="material-mobile-nav menu hamburger">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </button>
      </div>
    </div>
  </div>
</nav>

<div class="right-nav-menu-overlay" *ngIf="isNavOpen" [@rightMenuOverlayAnimation]></div>
<div class="right-nav-menu" [@rightNavAnimation]="isNavOpen ? 'open' : 'close'" [ngClass]="{ open: isNavOpen }">
  <div class="right-nav-menu-header">
    <a
      class="right-navbar-brand py-0"
      [routerLink]="['/']"
      routerLinkActive="router-link-active"
      attr.aria-label="{{ 'nav.home.page.screenreader' | translate: { fgbdefault: 'Move to home page' } }}"
    >
      <label id="homeLink" class="accessibility-only">Go To Home Page</label>
      <img class="nav-image" [src]="'logos/rewards-logo.png' | contentAssetImage" draggable="false" />
    </a>
    <!-- Close Button -->
    <button type="button" class="close-btn position-absolute" (click)="isNavOpen = false" aria-label="Close">
      <i class="material-icons">close</i>
    </button>
  </div>
  <div class="member-container">
    <div *ngIf="memberDetails$ | async as memberDetails" class="fw-bold name-text">
      {{ memberDetails!.FirstName }}
      {{ memberDetails!.Surname }}
    </div>
    <div class="member-id" *ngIf="{ card: card$ | async, memberDetail: memberDetails$ | async } as memberCard">
      <span> {{ memberCard.card?.ProductCode }} - {{ memberCard.memberDetail?.ExternalRefNumber }}</span>
    </div>
  </div>
  <div class="d-flex flex-column menu-container">
    <div class="right-nav-menu-list">
      <!-- Nav Buttons -->
      <ng-container *notInPopulation="[populations.TicketTransfer]">
        <a
          class="right-nav-menu-item"
          data-bs-dismiss="offcanvas"
          [routerLink]="['/account']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <span class="material-icons-outlined"> account_circle </span>
          <span class="nav-text">{{ 'nav.account' | translate }}</span>
        </a>

        <a
          class="right-nav-menu-item"
          data-bs-dismiss="offcanvas"
          [routerLink]="['/earn']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <span class="material-icons"> loyalty </span>
          <span class="nav-text">{{ 'nav.earn' | translate }}</span>
        </a>

        <a
          class="right-nav-menu-item"
          data-bs-dismiss="offcanvas"
          [routerLink]="['/gallery']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <span class="material-symbols-outlined"> animated_images </span>
          <span class="nav-text">{{ 'nav.gallery' | translate }}</span>
        </a>

        <div class="help-wrapper">
          <div class="right-nav-menu-item help-dropdown">
            <span class="material-icons">info</span>
            <span class="nav-text">{{ 'nav.help' | translate }}</span>
            <span class="material-icons arrow">expand_more</span>
          </div>

          <div class="help-submenu">
            <a class="right-nav-sub-item" data-bs-dismiss="offcanvas" [routerLink]="['/terms']">
              {{ 'nav.terms' | translate }}
            </a>
            <a class="right-nav-sub-item" data-bs-dismiss="offcanvas" [routerLink]="['/faq']">
              {{ 'nav.faq' | translate }}
            </a>
            <a class="right-nav-sub-item" data-bs-dismiss="offcanvas" [routerLink]="['/contact']">
              {{ 'nav.contact.us' | translate }}
            </a>
          </div>
        </div>
      </ng-container>

      <a class="log-out" data-bs-dismiss="offcanvas" (click)="logout()">
        <i class="material-icons font-size-14 fw-bold">logout</i>
        <div class="nav-text">{{ 'nav.log.out' | translate }}</div>
      </a>
    </div>
  </div>
</div>
